import React from "react";
import { DM1, DM2, DM3, DM4, DM5, newImg1, newImg4, saas, saasBanner } from "../../Assets.tsx";
import { ServiceShell, Section, Hero, Intro, Split, CheckList, Cta } from "../Common-component/ServiceKit";

const growth = [
  "Digital marketing services enable businesses of all sizes to continuously and affordably promote their brands.",
  "A digital marketing company may assist businesses of any size, from startups to large corporations with various locations, to expand their niche market reach and reach their target clients regardless of time zones or location.",
  "Working with a digital marketing agency is one of the finest ways to engage with prospects while maintaining a solid relationship with your present clientele.",
  "Your customers will always be able to find you if your company has a strong internet presence.",
];

const services = [
  {
    img: DM1,
    alt: "Search Engine Optimization",
    title: "Search Engine Optimization (SEO)",
    text: "We can help you get higher organic rankings and increased visibility in search results by carrying out in depth keyword research and implementing white-hat SEO strategies. Our internet marketing company offers Search Engine Optimization services like in depth keyword research, on page and off page optimization, and utilization of Google Search Console. These strategies allow us to increase your conversions as part of your digital marketing solutions by attracting high quality leads, visits and leads.",
  },
  {
    img: DM2,
    alt: "Email Marketing",
    title: "Email Marketing",
    text: "How many emails do you receive from businesses you delete every day? Make your email marketing efforts stand out and benefit your company by choosing ATUM Information Technology. We create personalized email newsletters to push your customers to take the necessary action and keep your emails from ending up in junk folders. Our team creates your subscriber list, checks email campaigns before sending, incorporates strong words into your content, and adds mystery to your emails.",
  },
  {
    img: DM3,
    alt: "Social Media Marketing",
    title: "Social Media Marketing",
    text: "Are you ready to increase your social media followers and promote them there? We create Social Media Marketing campaigns to advertise your company and interact with your fans on social media. Our digital marketing company analyzes your customers’ online behavior and goals and does competitive benchmarking. We create specialized paid advertising and social media brand management strategies for your company using data and analytics.",
  },
  {
    img: DM4,
    alt: "Content Marketing",
    title: "Content Marketing",
    text: "The content of your website is quite important because it forms the basis of your SEO and attracts many people. Trust ATUM Information Technology with the construction of your material, and we’ll write it precisely. To ensure that the information we produce complies with Google guidelines, our content marketing professionals keep up with news and industry developments. We structure your items to make them simpler to read, write engaging headlines, use strong keywords, and employ photos.",
  },
  {
    img: DM5,
    alt: "Search Engine Marketing",
    title: "Search Engine Marketing (SEM)",
    text: "Search engine marketing services have established their value over time. It is a dependable and affordable approach to drive traffic to your website and boost purchases to increase revenue. Today, more than 80% of people use search engines to make purchases, and statistics show that 95% of consumers favor businesses listed on the first page of search results. For these reasons, search engine marketing is crucial. Faster lead generation, brand recognition, local promotion, and conversion-focused sales are the targeted outcomes of SEM services at ATUM Information Technology.",
  },
  {
    img: newImg1,
    alt: "Social Media Optimization",
    title: "Social Media Optimization (SMO)",
    text: "We increase audience interest in your company by maximizing social media. We offer SMO services that improve client reach on social media by optimizing content like tags, descriptions, and more. SMO aims to increase traffic from sites besides search engines.",
  },
];

const benefits = [
  "Save your resources, time, and money",
  "Create a positive online reputation for your business",
  "Obtain enormous ROI",
  "Increase the number of consumer touchpoints",
  "Follow the progress of your campaign",
  "Encourage increased consumer involvement",
  "Adapt your tactics in view of analytics and data",
  "Encourage sustainable, profitable growth",
  "Utilize targeted audience analysis",
  "Raise the conversion rates",
];

const DigitalMarketingPage = () => (
  <ServiceShell>
    {/* HERO */}
    <Hero
      chip="Digital Marketing"
      title="Digital Marketing Services Grow Your Reach With Our Strategies"
      paragraphs={[
        "Digital marketing is advertising that uses the internet and digital devices like computers and smartphones to establish connections with consumers. Its objectives are similar to other marketing strategies to raise brand recognition, spur sales, and advertise products and services.",
      ]}
      tags={["SEO", "Email", "Social Media", "Content"]}
      img={newImg4}
      alt="Digital marketing"
    />

    {/* BUSINESS GROWTH */}
    <Section tint>
      <Split
        img={saasBanner}
        alt="Business growth"
        chip="Business Growth"
        title="How Digital Marketing Services Support Business Growth"
        sub="This is how digital marketing services support the growth of any organization or business:"
      >
        <CheckList items={growth} />
      </Split>
    </Section>

    {/* SERVICES */}
    <Section style={{ paddingBottom: 30 }}>
      <Intro chip="What We Do" title="Digital Marketing Services Provided At ATUM Information Technology" />
    </Section>
    {services.map((s, i) => (
      <Section key={s.title}>
        <Split
          img={s.img}
          alt={s.alt}
          reverse={i % 2 === 1}
          chip={"Service " + (i + 1)}
          title={s.title}
          paragraphs={[s.text]}
        />
      </Section>
    ))}

    {/* BENEFITS */}
    <Section tint>
      <Split
        img={saas}
        alt="Digital marketing benefits"
        reverse
        chip="Benefits"
        title="Benefits Of Our Digital Marketing Services"
        sub="You can boost your sales volume and create a solid digital basis with value driven internet marketing services. Digital marketing benefits go as follows:"
      >
        <CheckList items={benefits} />
      </Split>
    </Section>

    {/* WHY US */}
    <Cta
      chip="Why Us"
      title="Why Do Businesses Choose ATUM Information Technology?"
      paragraphs={[
        "We, the ATUM Information Technology, offer services that assist in finding the best solutions for our clients regarding strategy, consultation, digital technology, and operations. As a company that develops digital technologies, we have formed collaborations with organizations that pursue technological innovation as a broad strategy for approaching the digital world and how it functions. We have more than enough practical knowledge from working in more than 40 different business functions and industries to offer the finest outcomes in the rapidly changing technological and digital environment.",
      ]}
    />
  </ServiceShell>
);

export default DigitalMarketingPage;